import type { IReporte } from "../../modulos/reportes/interfaces";
import { IconBellFilled, IconChartPieFilled, IconClipboardList, IconFileAnalyticsFilled, IconTool } from '@tabler/icons-react';
import { EnumPermisos } from "../../globales/enums/enumPermisos";

export const listaReportesGenerales: IReporte[] = [
    {
        slug: 'emergencias',
        nombre: 'Emergencias',
        descripcion: 'Incidentes críticos en tiempo real',
        icono: <IconBellFilled size={18} />,
        url: 'https://app.powerbi.com/view?r=eyJrIjoiNjZjM2VmM2MtYWM5MS00NWE1LWE2YTgtZTcxYjc2MTIyMGJjIiwidCI6IjE1NGZmODBlLThmZjQtNGVhMy1iZDkxLTgwODUyNWU5ZjQwNSJ9&pageName=26755c0b6c3e8e9ed20e'
    },
    // {
    //     slug: 'atenciones',
    //     nombre: 'Atenciones',
    //     descripcion: 'Historial y seguimiento de atenciones',
    //     icono: <IconClipboardList size={18} />,
    //     permisoRequerido: EnumPermisos.PERMISO_REPORTE_ATENCIONES_VER,
    //     url: 'https://app.powerbi.com/view?r=eyJrIjoiNzQyMDI1MDUtZTkxOS00M2ZmLTk3M2UtNjhlYTdkMjIyYjc3IiwidCI6IjE1NGZmODBlLThmZjQtNGVhMy1iZDkxLTgwODUyNWU5ZjQwNSJ9'
    // },
    {
        slug: 'horas-hombre',
        nombre: 'Horas Hombre',
        descripcion: 'Productividad y tiempo por técnico en campo',
        icono: <IconTool size={18} />,
        permisoRequerido: EnumPermisos.PERMISO_REPORTE_HORAS_HOMBRE_VER,
        url: 'https://app.powerbi.com/view?r=eyJrIjoiMjFjMDJiMWMtMTY2Yy00YTdiLTljNDktMGQwOTE1MGNlYzk1IiwidCI6IjE1NGZmODBlLThmZjQtNGVhMy1iZDkxLTgwODUyNWU5ZjQwNSJ9'
    },
    {
        slug: 'contratos',
        nombre: 'Contratos',
        descripcion: 'Seguimiento y análisis de contratos',
        icono: <IconFileAnalyticsFilled size={18} />,
        url: 'https://app.powerbi.com/view?r=eyJrIjoiNWFmYzg0YTctZGExZi00YzViLWFlNzMtOTk3MmE5OGM4ZmZmIiwidCI6IjE1NGZmODBlLThmZjQtNGVhMy1iZDkxLTgwODUyNWU5ZjQwNSJ9'
    },
    {
        slug: 'proyectos-equipos',
        nombre: 'Proyectos y Equipos',
        descripcion: 'Seguimiento y análisis de proyectos y equipos',
        icono: <IconChartPieFilled size={18} />,
        url: 'https://app.powerbi.com/view?r=eyJrIjoiZDE2NWExNjQtZDQyMy00ZjQ5LTgxNDItZjNmYTZlMjVmNDNlIiwidCI6IjE1NGZmODBlLThmZjQtNGVhMy1iZDkxLTgwODUyNWU5ZjQwNSJ9'
    }
];

// Suprimir warning de import no usado cuando atenciones está comentado
void IconClipboardList;
